import Vue from 'vue'
import Vuex from 'vuex'

import data from './modules/data'
import blackbox from './modules/blackbox'
import customers from './modules/customers'
import users from './modules/users'
import sites from './modules/sites'
import models from './modules/models'
import utils from './modules/utils'
import charts from './modules/charts'
import datasheets from './modules/datasheets'
import vectors from './modules/vectors'
import indicators from './modules/indicators'
import session from './modules/session'
import report from './modules/report'
import reports from './modules/reports'
import diagnosi from './modules/diagnosi'
import dashboard from './modules/dashboard/dashboard'
import elastic from './modules/elastic'
import billaudit from './modules/billaudit'
import api from '@/services/api'
import jobs from './modules/jobs'
import router from '@/router'

var VueCookie = require('vue-cookie');
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const LOGIN = "LOGIN";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAILED = "LOGIN_FAILED";
const LOGOUT = "LOGOUT";

const getQueryParameter = (name) => {
  const searchValue = new URLSearchParams(location.search).get(name)
  if (searchValue) {
    return searchValue
  }

  const hashQueryIndex = location.hash.indexOf('?')
  if (hashQueryIndex === -1) {
    return null
  }

  return new URLSearchParams(location.hash.slice(hashQueryIndex + 1)).get(name)
}

export default new Vuex.Store({
  state: {
    isLoggedIn: !!(VueCookie.get('token') || getQueryParameter("token")),
    pending : false,
    isPrintLayout: false,
    user: {},
    sites: [],
    models: [],
    selectedSiteId: null,
    showLoading: 0,
    sidebarOpen: false,
    customerGuid: null,
    dashboardMonths: [],
    colors: [
      '#249846', '#154658', '#DC463E', '#721D20', '#743F79', '#9AC641', '#3F2F7A', '#F1D93C'
      , '#E67541', '#124628', '#3E79B0', '#4CBCD5', '#28826C', '#A1A4A0',
      '#3F4240', '#E0689C', '#43291B', '#EBA9A9', '#54391D', '#89705C'
    ],
    elementWidthValue: VueCookie.get('menuWidth') !== 'undefined' || VueCookie.get('menuWidth') !== null ? VueCookie.get('menuWidth') : 260
  },
  mutations: {
    [LOGIN] (state) {
      state.pending = true;
    },
    [LOGIN_SUCCESS] (state) {
      state.isLoggedIn = true;
      state.pending = false;
    },
    [LOGIN_FAILED] (state) {
      state.isLoggedIn = false;
      state.pending = false;
    },
    [LOGOUT](state) {
      VueCookie.delete('token')
      state.isLoggedIn = false;
    },
    loading(state) {
      state.showLoading += 1;
    },
    stopLoading(state) {
      state.showLoading = state.showLoading > 1 ? state.showLoading - 1 : 0;
    },
    user(state, data) {
      state.user = data
    },
    openMenu(state) {
      state.sidebarOpen = true
    },
    closeMenu(state) {
      state.sidebarOpen = false
    },
    customerGuid(state, guid) {
      state.customerGuid = guid
    },
    dashboardMonths(state, months) {
      state.dashboardMonths = months
    },
    setPrintLayout(state, isPrintLayout) {
      state.isPrintLayout = isPrintLayout
    },
    setSelectedSiteId(state, siteId) {
      state.selectedSiteId = siteId;
    },
    setWidth(state, elementWidth) {
      state.elementWidthValue = elementWidth
    }
  },
  getters: {
    getAllAvailableIndicators: (state) => {
      return 'sites' in state.user ?
        state.user.sites.reduce((indicators, site) => [...indicators, ...site.indicators], [])
        : [];
    },
    getAllAvailableParameters: (state) => {
      return 'sites' in state.user ?
        state.user.sites.reduce((parameters, site) => [...parameters, ...site.parameters], [])
        : [];
    },
    getAllAvailableChannels: (state) => {
      return 'sites' in state.user ?
        state.user.sites.reduce((channels, site) => [...channels, ...site.channels], [])
        : [];
    },
    getAdminStatus:(state) => {
      return state.user.superAdmin
    },
    userSites: (state) => {
      return state.user.sites
    }
  },
  actions: {
    changeParentSize({ commit }, data) {
      commit('setWidth', data)
    },
    clearState({ commit, dispatch }) {
      dispatch('dashboard/clear');
      dispatch('charts/clear');
      commit('setSelectedSiteId', null);
    },

    login({ commit }, creds) {
      commit(LOGIN);
      return new Promise((resolve, reject) => {
        api().post('/login', creds).then( (response) => {
          if(! response) {
            reject();
            return;
          }
          if(response.data.code == 1) {
            VueCookie.set('token', response.data.authorization)
            commit(LOGIN_SUCCESS);

            commit("user", response.data.data)
            resolve({ success: true });
          } else {
            commit(LOGIN_FAILED);
            resolve({ success: false, code: response.data.code, message: response.data.message });
          }
          /*if(response.data.code == -1) {
            commit(LOGIN_FAILED);
            resolve({ success: false, code: response.data.code });
          } 
          if(response.data.code == -2) {
            commit(LOGIN_FAILED);
            resolve({ success: false, code: response.data.code, message: response.data.message });
          }
          if(response.data.code == -3) {
            commit(LOGIN_FAILED);
            resolve({ success: false, code: response.data.code, message: response.data.message });
          }
          if(response.data.code == -4) {
            commit(LOGIN_FAILED);
            resolve({ success: false, code: response.data.code, message: response.data.message });
          }*/
          reject();
        })
      });
    },
    logout({ dispatch, commit }) {
      dispatch('clearState');

      //localStorage.removeItem("token");
      VueCookie.delete('token')
      commit(LOGOUT);
    },
    loadUser({ commit }) {
      return new Promise((resolve) => {
        api().post('/user').then( (response) => {
          if(! response)
            return;
          if(response.data.code == 1) {
            commit("user", response.data.data)
            if(response.data.data.level != 1) {
              commit("customerGuid", response.data.data.customerGuid)
            }
            resolve({ success: true });
          } else {
            commit(LOGIN_FAILED);
            resolve({ success: false });
          }
        })
      });
    },
    sql({ commit }, data) {
      return new Promise((resolve) => {
        api().post('/admin/sql', data).then( response => {
          resolve({ success: false });
        })
      })
    }
  },
  modules: {
    data,
    blackbox,
    customers,
    users,
    sites,
    models,
    utils,
    datasheets,
    charts,
    vectors,
    indicators,
    session,
    report,
    diagnosi,
    dashboard,
    reports,
    elastic,
    billaudit,
    jobs
  },
  strict: debug,
  plugins: []
})



// WEBPACK FOOTER //
// ./src/store/store.js